export const encodeId = (id) => {
  if (!id) return '';
  try {
    return btoa(id);
  } catch (e) {
    console.error('Error encoding ID:', e);
    return '';
  }
};

export const decodeId = (encodedId) => {
  if (!encodedId) return '';
  try {
    return atob(encodedId);
  } catch (e) {
    console.error('Error decoding ID:', e);
    return '';
  }
};
